<template>
  <div id="outcome" class="outcome">
    <div v-if="!predictError">
      <!-- Patient Summary -->
      <div>
        <div is="sui-header" class="summary-header">
          Patient Summary:
        </div>
        <div class="patient-summary">
          <patient-summary />
        </div>
      </div>

      <!-- Classification Info Tabs-->
      <sui-tab
        :menu="{ tabular: false, attached: true }"
        ref="outcome-tabs"
        class="outcome-tabs"
        :active-index.sync="activeIndex"
      >
        <sui-tab-pane
          ref="patient-tab"
          title="Patient Risk Assessment"
          :disabled="!hasResults"
        >
          <state-plots v-if="hasResults" />
        </sui-tab-pane>

        <sui-tab-pane
          ref="factors-tab"
          title="Patient Contributing Factors"
          :loading="thisPatientLoading"
          :disabled="!hasResults"
        >
          <transition-plot />
          <beta-z-plots />
        </sui-tab-pane>

        <sui-tab-pane
          ref="cohort-tab"
          title="Cohort Risk Stratification"
          :loading="averageLoading"
        >
          <risk-plots />
        </sui-tab-pane>

        <sui-tab-pane
          ref="hazard-tab"
          title="Cohort Hazard Ratios"
          class="forest-plots"
        >
          <forest-plots />
        </sui-tab-pane>
      </sui-tab>
    </div>
    <div v-else-if="predictError" class="predict-error">
      <i class="redo icon"></i> An error ocurred, please try again. If persists, please <a target="_blank" href="mailto:%22Elli%20Papaemmanuil%22%3Cpapaemme%40mskcc.org%3E?cc=%22Juan%20E.%20Arango-Ossa%22%3Carangooj%40mskcc.org%3E&subject=[Contact] AML Web Support Calculator">contact us.</a>
    </div>

    <div v-else-if="loading" class="general-loading">
      <div class="wait-warning">Running Model</div>
      <img src="../assets/loader.gif" />
    </div>

    <info-home v-else />
  </div>
</template>

<script>
import Vue from "vue";
import PatientSummary from "@/components/PatientSummary";
import StatePlots from "@/components/StatePlots";
import BetaZPlots from "@/components/BetaZPlots";
import TransitionPlot from "@/components/TransitionPlot";
import RiskPlots from "@/components/RiskStrata";
import ForestPlots from "@/components/ForestPlots";
import InfoHome from "@/components/InfoHome";
import { mapGetters } from "vuex";
import productTourSteps from "@/utils/tour";

export default {
  name: "PatientOutcome",
  components: {
    StatePlots,
    BetaZPlots,
    PatientSummary,
    TransitionPlot,
    RiskPlots,
    ForestPlots,
    InfoHome
  },
  data() {
    return {
      activeIndex: 2
    };
  },
  computed: {
    ...mapGetters([
      "thisPatientLoading",
      "newLoading",
      "elnLoading",
      "averageLoading",
      "hasResults",
      "predictError"
    ]),
    loading() {
      return this.elnLoading || this.newLoading || this.thisPatientLoading;
    }
  },
  watch: {
    hasResults(value) {
      // When there're results switch active tab from 'Risk Strata' -> 'Patient Risk'
      if (value) {
        Vue.nextTick(() => {
          this.activeIndex = 0;
        });
      } else {
        Vue.nextTick(() => {
          this.activeIndex = 2;
        });
      }
    }
  },
  mounted() {
    Vue.nextTick(() => {
      const tabs = [...document.querySelectorAll(".outcome-tabs a.item")]
      const steps = productTourSteps(tabs)
      this.$driver.defineSteps(steps)
    })
  }
};
</script>

<style lang="scss">
.outcome {
  margin: 24px;

  .main-warning {
    margin-bottom: 40px;
  }

  .ui.label {
    border-radius: 2px;
    border: 1px solid transparent;
    &.favorable {
      background-color: #039616;
      color: white;
    }
    &.intermediate {
      background-color: #f2994a;
      color: white;
    }
    &.adverse {
      background-color: #eb5757;
      color: white;
    }
    & {
      background-color: #2e68bd;
      color: white;
    }
  }

  .ui.button.blue {
    background-color: #2e68bd;
    &:hover {
      background-color: rgba(46, 104, 189, 0.8);
    }
  }

  .ui.header.summary-header {
    background: #f6f9ff;
    border: 1px solid #edeffa;
    border-radius: 4px 4px 0px 0px;
    color: #00113d;
    font-family: DM Sans;
    font-size: 22px;
    padding: 12px;
    margin: 0px;
    i {
      cursor: pointer;
      font-size: 16px;
      vertical-align: baseline;
    }
  }

  .forest-plots img {
    width: 100%;
    height: auto;
  }

  .patient-summary {
    display: flex;
    justify-content: space-between;
    border: 1px solid #edeffa;
    margin-bottom: 24px;
  }

  .outcome-tabs,
  .event-tabs {
    .ui.menu.attached,
    .ui.tab {
      border: 1px solid #edeffa;
    }
    .ui.menu .item {
      color: #7d859b;
      background: #f6f9ff;
      height: 50px;
      &.active {
        color: #1e4781;
        background: white;
        font-weight: bold;
      }
      span {
        font-family: DM Sans;
        font-size: 14px;
      }
    }
  }
  .predict-error {
    color: #00113d;
    font-family: DM Sans;
    font-size: 18px;
    font-weight: 300;
    padding: 16px;
    text-align: center;
    position: fixed;
    margin-left: calc(40% - 400px);
    span {
      cursor: pointer;
      font-weight: 700;
    }
  }
  .general-loading {
    img {
      display: block;
      margin: auto;
      margin-top: 20px;
    }
    div {
      display: block;
      margin: auto;
      text-align: center;
      font-size: 20px;
    }
  }
}
</style>
